import { useEffect, useMemo } from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import useMethodAccount from "../../MyAccount/hooks/useMethodAccount";
import { parseAccountIdsFromSearch } from "../../../../utils/myAccountTabUrl";
import { needsAction } from "../../../utils/TicketPassHelper";
import { filterReservationAssortTickets } from "./TicketsTab/filterReservationAssortTickets";
import { Ticket } from "../../../models/Ticket";
import { State } from "../../../store";

/**
 * Liczy bilety/karnety wymagające działania klienta (needsAction) — zasila kropkę/licznik
 * przy tabce "Bilety i karnety". Pobiera dane niezależnie od PassesList.tsx (osobny fetch,
 * bo licznik ma być widoczny niezależnie od tego, która zakładka jest aktywna) — powiela
 * ten sam merge (passes + tickets po trhId) i ten sam filtr co lista, żeby liczba na tabce
 * zgadzała się z tym, co user zobaczy po wejściu.
 */
export default function useAccountActionsCount() {
  const location = useLocation();
  const accountIds = parseAccountIdsFromSearch(location.search);
  const { passes, tickets, getLimited, getSelect } = useMethodAccount(accountIds);
  const showReservationsOnMyAccountPanel = useSelector(
    (state: State) => state.config.configuration.showReservationsOnMyAccountPanel,
  );

  useEffect(() => {
    getLimited();
    getSelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountIds]);

  return useMemo(() => {
    const map = new Map<string, Ticket>();
    (passes || []).forEach((p) => map.set(p.trhId, p));
    (tickets || []).forEach((t) => map.set(t.trhId, t));
    const merged = filterReservationAssortTickets(Array.from(map.values()), showReservationsOnMyAccountPanel);

    return merged.filter(needsAction).length;
  }, [passes, tickets, showReservationsOnMyAccountPanel]);
}
